import React from 'react';
import { render } from '@testing-library/react';
import Background from './Background';

test('background has svg', () => {
    const { container } = render(<Background />);
    const svgComponent = container.querySelector('svg');
    expect(svgComponent).not.toBeNull();
});
